export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

type DemoItem = {
    key: number
    role: 'ai' | 'user'
    content: string
    loading?: boolean
    streaming?: boolean
    typing?: boolean
    isMarkdown?: boolean
    completed?: boolean
};

interface Props {
    autoScrollActive: boolean
    roles: Record<string, any>
    items: DemoItem[]
}

const chunks = [
    '### 生产版 BubbleList 方案\n\n先把聊天区拆成 **单条消息层** 和 **列表协作层**，让 Bubble 只处理单条消息布局，Markdown 能力交给 XMarkdown。',
    '#### 列表层默认能力\n\n- 自动贴底\n- 上拉加载历史\n- 回到底部入口\n- 历史位置保持\n- 最后一条消息持续增长时的滚动协作',
    '#### 业务扩展建议\n\n1. `footer` 放重试、复制、继续追问等操作\n2. `extra` 放状态、耗时、tokens 等补充信息\n3. `listFooter` 放免责声明、上下文提示或输入区',
    '> 这样组件库负责通用协作能力，业务语义继续通过插槽按需组织，既能落地生产，也不会把 Bubble 做得太重。',
];

function createRoles(): Props['roles'] {
    return {
        ai: {
            placement: 'start',
            avatar: true,
            roleName: 'AI 助手',
        },
        user: {
            placement: 'end',
            avatar: true,
            roleName: '我',
            variant: 'outlined',
        },
    };
}

function createInitialItems(): DemoItem[] {
    return [
        {key: 1, role: 'user', content: '帮我设计一个生产可用的 BubbleList。'},
        {key: 2, role: 'ai', content: '', loading: true, streaming: true, typing: true, isMarkdown: true, completed: false},
    ];
}

function createState(): Props {
    return {
        autoScrollActive: true,
        roles: createRoles(),
        items: createInitialItems(),
    };
}

export default class extends Component<Props> {
    static template = template;

    private timer: number | null = null;

    static defaults() {
        return createState();
    }

    @bind
    handleAutoScrollChange(active: boolean) {
        this.set('autoScrollActive', active);
    }

    @bind
    handleTypingComplete(item: {key?: string | number}, _content?: string, _index?: number) {
        this.set({
            items: this.get('items').map((currentItem) => {
                if (currentItem.key !== item.key) return currentItem;

                return {
                    ...currentItem,
                    completed: true,
                };
            }),
        });
    }

    getTypingOptions(item: {typing?: unknown}) {
        return item.typing ? {interval: 24, step: 2} : false;
    }

    @bind
    startStreaming() {
        this.reset();

        let index = 0;
        const stream = () => {
            const nextContent = chunks.slice(0, index + 1).join('\n\n');
            this.set({
                items: [
                    this.get('items')[0],
                    {
                        key: 2,
                        role: 'ai',
                        content: nextContent,
                        loading: false,
                        streaming: index < chunks.length - 1,
                        typing: true,
                        isMarkdown: true,
                        completed: false,
                    },
                ],
            });

            index++;
            if (index < chunks.length) {
                this.timer = window.setTimeout(stream, 500);
            }
        };

        stream();
    }

    @bind
    reset() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }

        this.set({
            items: createInitialItems(),
        });
    }
}